import { ResponseCode } from '../features/events/MeetingRecorder';
import { apiV2 } from '../lib/baseAxios';
import { IVFSResponse } from './fileSystemService';

interface IOnlineEventResponse {
  eventId: string;
  provider: 'google' | 'microsoft' | 'zoom';
  name: string;
  startDateTime: string;
  endDateTime: string;
  webLink: string;
}
interface IEventResultResponseData {
  askToConnectCalendar: boolean;
  isGoogleCalendarConnected: boolean;
  isMicrosoftCalendarConnected: boolean;
  isZoomMeetingsConnected: boolean;
  events: IOnlineEventResponse[];
}
/**
 * Get Online Events in a focus period (Usually today and tomorrow)
 */
export async function getFocusOnlineEvents(
  timeZone: string
): Promise<IEventResultResponseData> {
  const response = await apiV2.get<IVFSResponse<IEventResultResponseData>>(
    `/meeting/me/events/focus?timeZone=${timeZone}`
  );
  return response.data.data;
}
/**
 * Bot joins a meeting (Microsoft Teams or Google Meet)
 */
export async function joinMyMeeting(
  webLink: string,
  timeZone: string
): Promise<IVFSResponse<{ code: ResponseCode } | undefined>> {
  const response = await apiV2.post<
    IVFSResponse<{ code: ResponseCode } | undefined>
  >('/meeting/me/bot/join', {
    webLink,
    timeZone,
  });
  return response.data;
}

export interface BotHistoryLogs {
  _id: string;
  provider: 'google' | 'microsoft' | 'zoom';
  scheduleTime: string;
  status: 'finished' | 'failed';
  message: string;
  title: string;
  eventTime: string | null;
  eventUrl: string;
}

/**
 * Get Bot history logs for a user
 */
export async function getBotHistory(
  timeZone: string
): Promise<{ logs: BotHistoryLogs[] }> {
  const response = await apiV2.get<IVFSResponse<{ logs: BotHistoryLogs[] }>>(
    `/meeting/me/bot/history?timeZone=${timeZone}`
  );
  return response.data?.data ?? { logs: [] };
}

export default {
  getFocusOnlineEvents,
  joinMyMeeting,
  getBotHistory,
};
